import { siteConfig } from "../config/siteConfig";
import { Facebook, Instagram, Globe } from "lucide-react";

const quickLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Rooms", href: "#rooms" },
  { label: "Restaurant", href: "#restaurant" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const { hotel, contact, bookingLinks, bookingChannels } = siteConfig;

  return (
    <footer
      data-testid="footer"
      className="bg-[#1A362D] text-[#FAF9F6]/85 pt-20 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src={hotel.logoUrl}
                alt={hotel.name}
                className="w-12 h-12 object-contain"
              />
              <div>
                <p className="font-display text-xl text-[#FAF9F6]">{hotel.name}</p>
                <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A059]">
                  {hotel.location}
                </p>
              </div>
            </div>
            <p className="font-display italic text-[#D4B06A] mb-4">
              {hotel.tagline}
            </p>
            <p className="text-sm text-[#FAF9F6]/70 leading-relaxed">
              A quiet sanctuary of Sri Lankan heritage and hospitality.
            </p>
          </div>

          <div>
            <p className="font-overline mb-5 text-[#C5A059]">Quick Links</p>
            <ul className="space-y-3">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm hover:text-[#C5A059] transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-overline mb-5 text-[#C5A059]">Contact</p>
            <ul className="space-y-3 text-sm">
              <li>{contact.address}</li>
              <li>
                <a
                  href={`tel:${contact.phone}`}
                  className="hover:text-[#C5A059]"
                >
                  {contact.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contact.email}`}
                  className="hover:text-[#C5A059]"
                >
                  {contact.email}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${contact.whatsapp}`}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-[#C5A059]"
                >
                  WhatsApp: +{contact.whatsapp}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-overline mb-5 text-[#C5A059]">Book With Us</p>
            <ul className="space-y-3 text-sm mb-6">
              {bookingChannels.showBookingCom && (
                <li>
                  <a
                    href={bookingLinks.bookingCom}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-[#C5A059]"
                    data-testid="footer-bookingcom"
                  >
                    Booking.com
                  </a>
                </li>
              )}
              {bookingChannels.showAgoda && (
                <li>
                  <a
                    href={bookingLinks.agoda}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-[#C5A059]"
                    data-testid="footer-agoda"
                  >
                    Agoda
                  </a>
                </li>
              )}
              {bookingChannels.showWhatsApp && (
                <li>
                  <a
                    href={`https://wa.me/${contact.whatsapp}`}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-[#C5A059]"
                    data-testid="footer-whatsapp"
                  >
                    WhatsApp
                  </a>
                </li>
              )}
            </ul>
            <div className="flex items-center gap-4">
              <a
                href={contact.social.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="hover:text-[#C5A059]"
              >
                <Facebook className="w-5 h-5" strokeWidth={1.5} />
              </a>
              <a
                href={contact.social.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="hover:text-[#C5A059]"
              >
                <Instagram className="w-5 h-5" strokeWidth={1.5} />
              </a>
              <a
                href={contact.social.tripadvisor}
                target="_blank"
                rel="noreferrer"
                aria-label="TripAdvisor"
                className="hover:text-[#C5A059]"
              >
                <Globe className="w-5 h-5" strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#FAF9F6]/15 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-[#FAF9F6]/60">
          <p>© {new Date().getFullYear()} {hotel.name}. All rights reserved.</p>
          <p className="tracking-widest uppercase">
            Crafted with care in Anuradhapura, Sri Lanka
          </p>
        </div>
      </div>
    </footer>
  );
}
